import { DateTime } from 'luxon';
export var useDaysWithMissedPunchCorrection = function (_a) {
    var punchCorrections = _a.punchCorrections;
    return ((punchCorrections === null || punchCorrections === void 0 ? void 0 : punchCorrections.map(function (_a) {
        var correctionDateTime = _a.correctionDateTime;
        return DateTime.fromISO(correctionDateTime);
    })) || []);
};
